$(document).ready(function () {
  $('#mobileSearchInput')
    .on('focus', function () {
      $(this).val(''); // Clear the input value
      $(this).attr('placeholder', ''); // Set placeholder to empty
    })
    .on('blur', function () {
      $(this).attr('placeholder', 'Search Website'); // Reset placeholder on blur
    });

  let prevPage = document.referrer.split('/');
  if (prevPage[4] == 'mountainstatefair' && window.location.pathname == '/search.aspx') {
    $('body').addClass('subpagetheme fair-landing-page');
  }
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');
  $('footerItems2 li').html(function (_, html) {
    return html.replace('All Rights Reserved.', '<br/>All Rights Reserved.');
  });
});

$(window).load(function () {
  // ---
});
